import Base from '../../announcements/base';

export default class extends Base {}
